export default __webpack_public_path__ + "adobe-acrobat-pro.4554a68e.png";